<form [formGroup]="form" class="form" *ngIf="formReady">
  <div class="form-body">

    <div *ngIf="isDealer; else manufacturerConditions" class="form-section">
      <app-form-row *ngIf="showDefaultConditions"
        [label]="'FORMS.CUSTOMER.CONDITIONS.USE_DEFAULT' | translateControl : form | async">
        <app-checkbox [options]="[{ isChecked: form.value.useDefaultConditions }]" [layoutMod]="['toggle']"
          [mainForm]="form" [controlName]="'useDefaultConditions'">
        </app-checkbox>
      </app-form-row>

      <app-form-row [label]="'FORMS.CUSTOMER.CONDITIONS.EK_SURCHARGE'| translateControl : conditionsForm | async">
        <app-input [type]="'number'" [mainForm]="conditionsForm" [controlName]="'surcharge'" [suffix]="'percent'" datatestid="surchargeInput">
        </app-input>
      </app-form-row>

      <app-form-row [label]="'FORMS.CUSTOMER.CONDITIONS.PL_DISCOUNT'| translateControl : conditionsForm | async">
        <app-input [type]="'number'" [mainForm]="conditionsForm" [controlName]="'discount'" [suffix]="'percent'" datatestid="discountInput">
        </app-input>
      </app-form-row>

      <app-form-row [label]="['FORMS.CUSTOMER.CONDITIONS.TYPE'] | translateControl : conditionsForm | async">
        <div class="row">
          <div class="col-6">
            <app-radio [options]="radioData.conditionsTypes" [mainForm]="conditionsForm" [controlName]="'type'"
              [labelKey]="'title'" [valueKey]="'value'" [layoutMod]="['w50', 'stitched']">
            </app-radio>
          </div>
        </div>
      </app-form-row>

      <app-form-row [label]="'FORMS.CUSTOMER.CONDITIONS.PL_CODE'| translateControl : form | async">
        <app-input [type]="'text'" [mainForm]="conditionsForm" [controlName]="'plCustomerCode'">
        </app-input>
      </app-form-row>

      <app-form-row [label]="'FORMS.CUSTOMER.CONDITIONS.SYSTEM_NR'| translateControl : form | async">
        <app-input [type]="'text'" [mainForm]="conditionsForm" [controlName]="'externalSystemId'">
        </app-input>
      </app-form-row>

    </div>

    <ng-template #manufacturerConditions>

      <div class="form-section">
        <app-form-row [label]="'FORMS.CUSTOMER.CONDITIONS_MANUFACTURER.BASE_DISCOUNT'| translateControl : form | async">
          <app-input [type]="'text'" [mainForm]="form" [controlName]="'baseDiscount'">
          </app-input>
        </app-form-row>

        <app-form-row [label]="'FORMS.CUSTOMER.CONDITIONS_MANUFACTURER.SURCHARGE'| translateControl : form | async">
          <app-input [type]="'text'" [mainForm]="form" [controlName]="'surcharge'">
          </app-input>
        </app-form-row>

        <app-form-row
          [label]="'FORMS.CUSTOMER.CONDITIONS_MANUFACTURER.PAYMENT_CONDITIONS'| translateControl : form | async">
          <app-input [type]="'text'" [mainForm]="form" [controlName]="'paymentConditions'">
          </app-input>
        </app-form-row>

        <app-form-row [label]="'FORMS.CUSTOMER.CONDITIONS_MANUFACTURER.VAT'| translateControl : form | async">
          <app-input [type]="'text'" [mainForm]="form" [controlName]="'vat'">
          </app-input>
        </app-form-row>
      </div>

    </ng-template>

  </div>
</form>
